import { useEffect, useState } from 'react';

const useWindowLoaded = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsLoaded(true);
    }
  }, []);

  return isLoaded;
};

export default useWindowLoaded;
